function initMortgageCalculator(price) {
    var calculateButton = document.getElementById("calculateButton"),
        resetButton = document.querySelector("button[type='reset']"),
        closeButton = document.querySelector("#close-calculator"),
        mortgageCalculatorModal = $('#monthlyPaymentModal'),
        closeButtonPL = document.querySelector("#monthlyPaymentModal .close-button"),
        estimatedMontlyPaymentInfo = document.querySelector("#estimatedMontlyPaymentInfo");

    // Attach the formatAnnualInterestRate function to the input element's oninput event
    document.getElementById('annualInterestRate').addEventListener('input', formatAnnualInterestRate);

    $(document).ready(function () {
        $("#salesPrice").val(numberWithCommas($("#salesPrice").val()));
    });

    if (calculateButton) {
        calculateButton.addEventListener("click", function () {
            const PRICE_INPUT = $("#salesPrice"),
                  PAYMENT_INPUT =  $("#downPayment"),
                  INTEREST_INPUT = $("#annualInterestRate");

            var yearsVal = document.querySelector('input[name="mortgageTermLength"]:checked').value,
                interestRateVal = parseFloat(INTEREST_INPUT.val()),
                salesPriceVal = parseFloat(PRICE_INPUT.val().replace(/,/g, '')),
                downPaymentVal = parseFloat(PAYMENT_INPUT.val().replace(/,/g, ''));

            $("#emi-result-container").hide();
            var isValid = true;
            
            if (!salesPriceVal || salesPriceVal == null) {
                $("#salesPriceError").show();
                PRICE_INPUT.parent().addClass("has-error");
                PRICE_INPUT.attr({"aria-invalid": "true", "aria-describedby": "salesPriceHelpText"});
                isValid = false;
            } else {
                $("#salesPriceError").hide();
                PRICE_INPUT.parent().removeClass("has-error");
                PRICE_INPUT.removeAttr("aria-invalid aria-describedby");
            }
            if (!downPaymentVal || downPaymentVal == null) {
                $("#downPaymentError").show();
                PAYMENT_INPUT.parent().addClass("has-error");
                PAYMENT_INPUT.attr({"aria-invalid": "true", "aria-describedby": "downPaymentHelpText"});
                isValid = false;
            } else {
                $("#downPaymentError").hide();
                PAYMENT_INPUT.parent().removeClass("has-error");
                PAYMENT_INPUT.removeAttr("aria-invalid aria-describedby");
            }
            if (!interestRateVal || interestRateVal == null) {
                $("#annualInterestRateError").show();
                INTEREST_INPUT.parent().addClass("has-error");
                INTEREST_INPUT.attr({"aria-invalid": "true", "aria-describedby": "annualInterestRateHelpText"});
                isValid = false;
            } else {
                $("#annualInterestRateError").hide();
                INTEREST_INPUT.parent().removeClass("has-error");
                INTEREST_INPUT.removeAttr("aria-invalid aria-describedby");
            }
            // Check if down payment is greater than sale price
            if (downPaymentVal > salesPriceVal) {
                $("#lowerDownSales").show();
                return;
            }
            else {
                $("#lowerDownSales").hide();
            }
            if (isValid) {
                // Calculate monthly interest rate
                var monthlyInterestRate = (interestRateVal / 100) / 12;
                // Calculate number of monthly payments
                var numberOfPayments = yearsVal * 12;
                // Calculate the monthly payment (EMI)
                var emi = (salesPriceVal - downPaymentVal) * (monthlyInterestRate * Math.pow(1 + monthlyInterestRate, numberOfPayments)) /
                    (Math.pow(1 + monthlyInterestRate, numberOfPayments) - 1);
                // Display the result
                document.getElementById("emiResult").innerText = "$" + numberWithCommas(emi.toFixed(2));
                // Display calculated result on estimated montly payments 
                if (estimatedMontlyPaymentInfo) {
                    estimatedMontlyPaymentInfo.innerText = "";
                    estimatedMontlyPaymentInfo.innerText = "$" + numberWithCommas(emi.toFixed(2));
                }
                $("#emi-result-container").show();

                // Scroll the results into view
                const CALCULATOR_DISCLAIMER = $("#calculatorDisclaimer");
                CALCULATOR_DISCLAIMER[0]?.scrollIntoView({ behavior: 'smooth', block: 'start' });
            }
        });
    }

    if (mortgageCalculatorModal) {
        mortgageCalculatorModal.on('closed.zf.reveal', function (event) {
            resetForm();
        });
    }

    if (resetButton) {
        // Reset the form when "Cancel" button is clicked
        resetButton.addEventListener("click", function () {
            resetForm();
        });
    }

    if (closeButton) {
        closeButton.addEventListener("click", function () {
            resetForm();
        });
    }

    if (closeButtonPL) {
        closeButtonPL.addEventListener("click", function () {
            resetForm();
        });
    }

    function resetForm() {
        $("#salesPrice").val(numberWithCommas(price));
        $("#downPayment").val("");
        document.getElementById("yrs30").checked = true;
        $("#annualInterestRate").val("");
        // Hide any error messages and remove error classes
        $(".calculator-form-error").hide();
        $(".form-input-container").removeClass("has-error");
        // Hide the result container
        $("#emi-result-container").hide();
    }


    $("#salesPrice").on('input', function () {
        formatInputWithCommas(this);
    });

    $("#downPayment").on('input', function () {
        formatInputWithCommas(this);
    });

    function formatInputWithCommas(inputElement) {
        // Remove non-numeric characters and commas
        const numericValue = inputElement.value.replace(/[^0-9]/g, '');
        // Add commas as thousands separators
        const formattedValue = numberWithCommas(numericValue);
        // Update the input field with the formatted value
        inputElement.value = formattedValue;
    }
    function numberWithCommas(x) {
        return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }
    // Define a function to format the annual interest rate input
    function formatAnnualInterestRate(event) {
        // Get the value of the input element
        let inputValue = event.target.value;
    
        // Remove any non-numeric characters except dot (.)
        inputValue = inputValue.replace(/[^0-9.]/g, '');
        inputValue= inputValue.replace(/\.{2,}/g, '.');
        // Split the value into parts using dot (.) as separator
        let parts = inputValue.split('.');
    
        // If there are more than one part
        if (parts.length > 2) {
            // Only take the first part and the first part of the second split
            inputValue = parts[0] + '.' + parts[1];
        } else if (parts.length === 2) {
            // If there's a second part, limit it up to five digit
            parts[1] = parts[1].slice(0, 5);
    
            // Join the parts with a dot (.)
            inputValue = parts.join('.');
        } else {
            // If there's only one part, limit it to two digits
            inputValue = inputValue.slice(0, 2);
        }
    
        // Set the formatted value back to the input element
        event.target.value = inputValue;
    }
}

window.initMortgageCalculator = initMortgageCalculator;